import React, { useEffect, useState } from "react";
import { decodeJWT, LoadingIndicator } from "../../../lib/iprs-react-library/src/index.js";
import PaymentForm from "./PaymentForm";
import PrePaymentNotice from "./PrePaymentNotice.jsx";
import AWGPrePaymentNotice from "./AWGPrePaymentNotice.jsx";

const BrandKey_Payment_Cost = "Payment Cost";
const AWG_CLIENT_IDS = [36478, 75481];

const Payment = ({ api, handleReviewOrPay, appState }) => {

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const [cancellationFeeValue, setCancellationFeeValue] = useState("1.00"); 
    useEffect(() => {
        const decodedToken = decodeJWT(api.getToken());
        const params = {};
        if(decodedToken.CaseID){
            params.CaseID = decodedToken.CaseID;
        } else if(appState.websiteConfig?.CaseID){
            params.CaseID = appState.websiteConfig?.CaseID;
        }else{
            params.ClientID = appState.websiteConfig?.ClientPartyID;
        };
        setLoading(true);
        api.transact("GetBrandingInfo", params)
            .then(r=>r.apiResult)
            .then(r=>r.Settings)
            .then(settings=>{
                setCancellationFeeValue(settings[BrandKey_Payment_Cost])
            })
            .catch(e=>{
                setError(e.message);
            })
            .finally(()=>{
                setLoading(false);
            });
    }, [api, appState.websiteConfig?.CaseID, appState.websiteConfig?.ClientPartyID]);

    return (
        <div>
            {error && <div>Error: {error}</div>}
            {AWG_CLIENT_IDS.includes(Number.parseInt(appState.websiteConfig?.ClientPartyID))
                ? <AWGPrePaymentNotice />
                : <PrePaymentNotice cancellationFeeValue={cancellationFeeValue} />
            }
            {error && <div>Error: {error}</div>}
            <LoadingIndicator loading={loading} />
            <PaymentForm
                api={api}
                setError={setError}
                token={api.getToken()}
                handleReviewOrPay={handleReviewOrPay}
            />
            {error && <div>Error: {error}</div>}
        </div>
    );
};

export default Payment;
